import React, { useContext, useEffect } from "react";
import { Outlet, NavLink } from "react-router-dom";
import styles from "../styles/SettingsPage.module.css";
import { AuthContext } from "../AuthProvider";
import { AvatarContext } from "../contexts/AvatarContext";
import { UserContext } from "../contexts/UserContext";
// import { useKeycloak } from "@react-keycloak/web";

const SettingsPage = () => {
  const { keycloak, authenticated } = useContext(AuthContext);
  const { avatarUrl } = useContext(AvatarContext);
  const { setAvatarUrl } = useContext(AvatarContext);
  const { userInfo } = useContext(UserContext);
  //   const { keycloak } = useKeycloak();
  const user = userInfo || keycloak?.tokenParsed;

  // Extract user initials
  const getUserInitials = () => {
    if (!user) return "U"; // Default Initial
    const firstName = user.firstName || user.given_name || "";
    const lastName = user.lastName || user.family_name || "";
    return `${firstName.charAt(0)}${lastName.charAt(0)}`.toUpperCase();
  };

  useEffect(() => {
    if (authenticated) {
      const avatar = (userInfo && userInfo.picture) || keycloak?.tokenParsed?.picture;
      if (avatar) {
        setAvatarUrl(avatar);
      }
    }
  }, [authenticated, keycloak?.tokenParsed, setAvatarUrl, userInfo]);

  return (
    <div className={styles.settingsContainer}>
      {/* Left Section: User Info & Navigation */}
      <div className={styles.sidebar}>
        <div className={styles.avatar}>
          {avatarUrl ? (
            <img
              src={avatarUrl}
              alt="User Avatar"
              className={styles.avatarImage}
            />
          ) : (
            <>{getUserInitials()}</>
          )}
        </div>
        <h2 className={styles.username}>
          {(user?.firstName || user?.given_name) || ""} {(user?.lastName || user?.family_name) || ""}
        </h2>
        {(user?.username || user.preferred_username) && (
          <p className={styles.userHandle}>{user.username || user.preferred_username}</p>
        )}

        <nav className={styles.navMenu}>
          {/* <NavLink
            to="profile"
            className={({ isActive }) =>
              isActive ? styles.activeLink : styles.navLink
            }
          >
            Profile
          </NavLink> */}
          <NavLink
            to="account"
            className={({ isActive }) =>
              isActive ? styles.activeLink : styles.navLink
            }
          >
            Account
          </NavLink>
          <NavLink
            to="tokens"
            className={({ isActive }) =>
              isActive ? styles.activeLink : styles.navLink
            }
          >
            Hub API Tokens
          </NavLink>
          <NavLink
            to="tasks"
            className={({ isActive }) =>
              isActive ? styles.activeLink : styles.navLink
            }
          >
            My Runs
          </NavLink>
        </nav>
      </div>

      {/* Right Section: Dynamic Content */}
      <div className={styles.content}>
        <Outlet />
      </div>
    </div>
  );
};

export default SettingsPage;
